const AUTH_TOKEN_CACHE = 'accessTokenWebview'

export function webviewAccessTokenGet(): string {
  if (!window) return ''
  const authToken = sessionStorage.getItem(AUTH_TOKEN_CACHE)
  if (!authToken) return ''
  return JSON.parse(authToken)
}

export function webviewAccessTokenSet(authToken: string) {
  if (!window) return
  sessionStorage.setItem(AUTH_TOKEN_CACHE, JSON.stringify(authToken))
}

export function webviewAccessTokenReset() {
  if (!window) return
  sessionStorage.removeItem(AUTH_TOKEN_CACHE)
}
